module.exports = __webpack_public_path__ + "static/media/logo.b7df67ec.svg";